import type { AnatomyBinding } from "./componentAnatomy";
import { anatomyTextStyle } from "./componentAnatomyText";

// Geometry and colour bindings every Picker variant shares, mined from
// designSystem/Picker/Picker.module.scss and PickerItem.module.scss plus the
// Button primary block the field trigger renders through.

export const pickerSharedBindings: readonly AnatomyBinding[] = [
    {
        partId: "background",
        property: "height",
        literal: "28px",
        note: "Button md; the trigger is a Button primary md instance.",
    },
    { partId: "border", property: "border-width", token: "--border-width" },
    { partId: "border", property: "border-radius", token: "--radius-m" },
    {
        partId: "background",
        property: "padding-inline",
        token: "--space-8",
        via: "--button-padding-x",
    },
    ...anatomyTextStyle({
        scale: "s",
        weight: "500",
        mixin: "text-s-14-medium",
        note: "Button md label style.",
    }),
    { partId: "glyph", property: "width", literal: "16px" },
    { partId: "glyph", property: "height", literal: "16px" },
    {
        partId: "surface",
        property: "background-color",
        token: "--bg-primary",
    },
    { partId: "surface", property: "border-color", token: "--border-divider" },
    { partId: "surface", property: "border-width", token: "--border-width" },
    { partId: "surface", property: "border-radius", token: "--radius-m" },
    { partId: "surface", property: "box-shadow", token: "--shadow-2" },
    {
        partId: "surface",
        property: "padding",
        literal: "var(--space-4) 0",
        note: "Figma 3966:6939: rows sit 4px inside the border top and bottom (Figma's 1px popup padding sits under its inside stroke); the search bar bleeds over the top inset.",
    },
    {
        partId: "surface",
        property: "row-gap",
        token: "--space-4",
        note: "Search bar, sections and separators stack 4px apart.",
    },
    {
        partId: "section",
        property: "padding-inline",
        token: "--space-4",
        note: "Rows sit 5px from the popup's outer edge: 1px border + 4px inset.",
    },
    { partId: "section", property: "row-gap", token: "--space-2" },
    {
        partId: "itemBackground",
        property: "min-height",
        literal: "28px",
        via: "--_picker-item-height",
    },
    {
        partId: "itemBackground",
        property: "padding-inline",
        token: "--space-8",
    },
    {
        partId: "itemBackground",
        property: "border-radius",
        token: "--radius-xs",
    },
    { partId: "itemBackground", property: "gap", token: "--space-8" },
    ...anatomyTextStyle({
        scale: "s",
        weight: "400",
        mixin: "text-s-14-regular",
        partId: "itemLabel",
    }),
    { partId: "indicator", property: "width", literal: "16px" },
    { partId: "indicator", property: "height", literal: "16px" },
    ...anatomyTextStyle({
        scale: "xs",
        weight: "400",
        mixin: "text-xs-12-regular",
        partId: "sectionTitle",
    }),
    { partId: "sectionTitle", property: "color", token: "--fg-secondary" },
    {
        partId: "sectionTitle",
        property: "padding",
        literal: "5px var(--space-8)",
        note: "5px block padding is Figma's 28px title around 18px text.",
    },
    { partId: "separator", property: "height", token: "--border-width" },
    {
        partId: "separator",
        property: "background-color",
        token: "--border-divider",
    },
    {
        partId: "separator",
        property: "margin-block",
        token: "--space-2",
        note: "The 2px block margin plus the 2px list gap puts the line 4px from the rows on both sides.",
    },
    {
        partId: "separator",
        property: "margin-inline",
        literal: "calc(-1 * var(--space-4))",
        note: "Pulled over the list's 4px inset, so the line spans the full width between the popup borders.",
    },
];
